import SectionHeading from '@/pages/home/components/SectionHeading';
import { collections } from '@/mocks/home';

export default function CollectionsSection() {
  return (
    <section id="collections" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="合集索引"
            title="从合集入口开始逛"
            desc="六个封面合集覆盖当事人、涉事方与关联人物，先挑一个角度切入，再顺着关系往下走。"
          />
          <a
            href="#people"
            className="flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部条目
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {collections.map((item) => (
            <a
              key={item.title}
              href="#people"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} 封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 font-label text-xs text-foreground-800 backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h4 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h4>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                  <span className="font-label text-xs text-foreground-500">{item.count}</span>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
                    进入合集
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}